import type { ServiceGetByIdResponse } from '@/types/service'

import type {
  RecapShapeKep,
  RecapShapeKepDetail,
  RecapShapeKepMeta,
  RecapShapeKepSummary
} from './types'

type RecordType = 'detail' | 'summary'

export type RecapShapeKepRecord<TType extends RecordType> =
  TType extends 'detail'
    ? RecapShapeKepDetail & { recordType: 'detail' }
    : RecapShapeKepSummary & { recordType: 'summary' }

export type RecapShapeKepData = Array<
  RecapShapeKepRecord<'detail'> | RecapShapeKepRecord<'summary'>
>

export interface RecapShapeKepQueryResult {
  data: RecapShapeKepData
  meta?: RecapShapeKepMeta | null
}

type RecapShapeKepApiResponse = ServiceGetByIdResponse<RecapShapeKep> & {
  meta?: RecapShapeKepMeta
}

export function toRecords(
  json: RecapShapeKepApiResponse
): RecapShapeKepQueryResult {
  const data = json.data

  if (!data) {
    return {
      data: [],
      meta: json.meta ?? null
    }
  }

  const summary = [
    {
      ...data.summary,
      recordType: 'summary'
    } satisfies RecapShapeKepRecord<'summary'>
  ]

  const details = data.detail.map(
    item =>
      ({
        ...item,
        recordType: 'detail'
      }) satisfies RecapShapeKepRecord<'detail'>
  )

  return {
    data: [...details, ...summary],
    meta: json.meta ?? null
  }
}
